/* eslint-disable react/no-unescaped-entities */
/**
 * Pagina informativa Property Advisor (canonica, standalone).
 * Collegata alla CTA "Scopri le condizioni di adesione" della landing
 * Professionisti. Testi autonomi: NON riusa CoCSections (condiviso con
 * registrazione e /perche-vg), per non modificare quelle pagine.
 */
import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const TOOLS = [
  ["Dashboard professionale", "panoramica del lavoro, delle attività e delle opportunità."],
  ["Gestione Lead", "organizzazione e gestione dei contatti in ingresso."],
  ["Rete professionale", "sviluppo e gestione della propria rete."],
  ["Link personale e QR Code", "strumenti dedicati alla lead generation."],
  ["Social Coach AI", "supporto alla comunicazione sui social."],
  ["Strategy Coach AI", "supporto alla strategia professionale."],
  ["Sara AI", "assistente intelligente a supporto dell'attività."],
];

const STEPS = [
  {
    title: "L'utente esplora le possibilità",
    body: (
      <>
        Una persona accede a ValutaGenio direttamente oppure attraverso il link
        personale di un Property Advisor. Attraverso il percorso{" "}
        <strong>VALUTA → DECIDI → AGISCI</strong>, può descrivere il proprio
        immobile, ottenere una prima valutazione orientativa, confrontare le
        alternative e individuare una direzione. La valutazione è uno strumento
        di orientamento basato sulle informazioni e sui dati disponibili, non
        una perizia certificata.
      </>
    ),
  },
  {
    title: "Nasce una richiesta di confronto",
    body: (
      <>
        Quando desidera approfondire, l'utente può richiedere un primo confronto
        gratuito con un Property Advisor. Il professionista utilizza le
        informazioni effettivamente disponibili nella piattaforma e quelle
        condivise dall'utente per preparare l'incontro. La presenza di
        un'analisi in ValutaGenio non comporta automaticamente l'assegnazione di
        un contatto o la disponibilità di un dossier completo nella dashboard
        professionale.
      </>
    ),
  },
  {
    title: "Il primo incontro: Sostegno, Orientamento, Guida",
    body: (
      <>
        Il primo confronto gratuito, della durata indicativa di 30 minuti, ha lo
        scopo di offrire valore concreto alla persona. Si sviluppa attraverso
        tre competenze:
        <ul className="mt-3 space-y-2 list-none pl-0">
          <li>
            <strong>Sostegno:</strong> ascoltare la persona, comprenderne
            esigenze e obiettivi e costruire fiducia.
          </li>
          <li>
            <strong>Orientamento:</strong> aiutarla a interpretare le
            alternative, chiarire le priorità e riconoscere le opportunità.
          </li>
          <li>
            <strong>Guida:</strong> mettere a disposizione esperienza e
            competenza per individuare i passi successivi.
          </li>
        </ul>
        <span className="block mt-3">
          L'obiettivo è aiutare la persona a comprendere meglio la propria
          situazione, senza pressioni commerciali o obblighi di incarico.
        </span>
      </>
    ),
  },
  {
    title: "Dalla fiducia alla collaborazione",
    body: (
      <>
        Il primo incontro può rappresentare l'inizio di una relazione
        professionale. Se entrambe le parti desiderano proseguire, possono
        concordare autonomamente un incarico, una consulenza, un progetto o un
        percorso di collaborazione. L'eventuale accordo viene definito
        direttamente tra cliente e professionista, secondo le regole applicabili
        alla professione esercitata. ValutaGenio non diventa parte dell'accordo
        e non percepisce commissioni sull'incarico professionale.
      </>
    ),
  },
  {
    title: "La rete professionale",
    body: (
      <>
        Il Property Advisor può invitare altri professionisti a conoscere e
        utilizzare ValutaGenio, sviluppando la propria rete. Il programma
        referral riconosce gli eventuali compensi secondo le quote effettivamente
        pagate, le generazioni previste e le condizioni applicabili. La crescita
        della rete rappresenta un'attività distinta dalla consulenza immobiliare.
      </>
    ),
  },
];

const RULES = [
  {
    title: "Il primo incontro offre valore, non pressione commerciale.",
    body: "La consulenza iniziale gratuita è dedicata all'ascolto, all'orientamento e alla comprensione delle possibilità. Non deve trasformarsi in un'occasione per esercitare pressioni commerciali o imporre un incarico. Se emerge un interesse reciproco a proseguire, il professionista può presentare le proprie competenze e concordare successivamente un rapporto professionale.",
  },
  {
    title: "Gli incarichi sono autonomi.",
    body: "Gli eventuali accordi successivi vengono definiti direttamente tra cliente e professionista. Compensi, responsabilità e condizioni contrattuali seguono le regole della professione esercitata. ValutaGenio non media né percepisce commissioni su questi accordi.",
  },
  {
    title: "Riservatezza e protezione dei dati.",
    body: "Le informazioni ricevute attraverso ValutaGenio devono essere utilizzate esclusivamente per le finalità professionali autorizzate. Non possono essere diffuse a terzi o impiegate per scopi diversi senza un'adeguata base giuridica.",
  },
  {
    title: "Trasparenza sulle competenze.",
    body: "Ogni Property Advisor deve rappresentare correttamente qualifiche, abilitazioni, specializzazioni ed esperienza. Non deve svolgere attività riservate a professioni per le quali non possiede i requisiti previsti dalla legge. Quando necessario, deve indirizzare la persona verso professionisti adeguatamente qualificati.",
  },
  {
    title: "Correttezza nella rete professionale.",
    body: "Chi invita altri professionisti deve presentare ValutaGenio in modo trasparente, illustrando correttamente costi, strumenti, opportunità e condizioni del programma referral. Non sono ammesse promesse di compensi certi o risultati garantiti.",
  },
  {
    title: "Pari attenzione a ogni persona.",
    body: "Ogni richiesta merita rispetto, ascolto e professionalità, indipendentemente dal valore economico dell'immobile o dalle prospettive di incarico. La qualità del primo orientamento è uno dei fondamenti della fiducia in ValutaGenio.",
  },
];

export default function CodiceCondottaPage() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/"><Logo size={24} /></Link>
          <Link to="/signup" className="text-sm text-[#B40101] font-semibold hover:underline"
                data-testid="coc-back-to-signup">
            ← Torna alla registrazione
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-10">
        <h1 className="text-3xl font-bold text-[#0A0A0A] mb-3" data-testid="coc-title">
          Diventare Property Advisor: opportunità, funzionamento e regole
        </h1>
        <p className="text-[15px] leading-relaxed text-gray-600 mb-12" data-testid="coc-subtitle">
          Prima di aderire a ValutaGenio, scopri gli strumenti a tua
          disposizione, come funziona il rapporto con gli utenti e quali principi
          regolano l'attività dei Property Advisor.
        </p>

        <div className="space-y-14" data-testid="coc-body">
          {/* 2 · PERCHÉ */}
          <section data-testid="coc-section-perche">
            <h2 className="text-2xl font-bold text-[#0A0A0A] mb-4">
              Una nuova opportunità professionale
            </h2>
            <div className="space-y-4 text-[15px] leading-relaxed text-[#0A0A0A]">
              <p>
                Ogni giorno, persone e professionisti valutano immobili per
                venderli, acquistarli, affittarli, ristrutturarli o valorizzarli.
                Spesso hanno bisogno di comprendere le alternative prima di
                prendere una decisione.
              </p>
              <p>
                ValutaGenio li aiuta a esplorare il potenziale immobiliare
                attraverso un percorso di analisi e confronto. Quando desiderano
                approfondire, possono richiedere un primo orientamento
                professionale gratuito.
              </p>
              <p>
                Per un Property Advisor significa poter entrare in contatto con
                persone che hanno già iniziato a ragionare su un'operazione
                immobiliare concreta. Non si tratta semplicemente di ricevere
                nominativi, ma di costruire relazioni professionali a partire da
                esigenze e obiettivi già individuati.
              </p>
            </div>

            <h3 className="text-base font-semibold text-[#0A0A0A] mt-8 mb-3">
              Gli strumenti a tua disposizione
            </h3>
            <p className="text-[15px] leading-relaxed text-[#0A0A0A] mb-4">
              Con l'adesione a ValutaGenio, al costo di 79 €/mese, accedi
              all'ambiente professionale della piattaforma. Gli strumenti
              comprendono:
            </p>
            <ul className="space-y-3 list-none pl-0" data-testid="coc-strumenti">
              {TOOLS.map(([title, desc]) => (
                <li key={title} className="pl-6 relative text-[15px] leading-relaxed text-[#0A0A0A]">
                  <span className="absolute left-0 top-1.5 w-2 h-2 rounded-full bg-[#B40101]" />
                  <strong>{title}:</strong> {desc}
                </li>
              ))}
            </ul>

            <h3 className="text-base font-semibold text-[#0A0A0A] mt-8 mb-3">
              Il programma referral
            </h3>
            <div className="space-y-4 text-[15px] leading-relaxed text-[#0A0A0A]">
              <p>
                ValutaGenio offre anche la possibilità di sviluppare una rete di
                professionisti. Quando inviti altri professionisti ad aderire,
                puoi maturare compensi sulle quote di abbonamento effettivamente
                pagate, secondo le condizioni del programma, il livello raggiunto
                e le regole applicabili. Il programma si sviluppa su tre
                generazioni di rete.
              </p>
              <p>
                Il referral rappresenta un'opportunità aggiuntiva rispetto
                all'attività immobiliare e non modifica il rapporto professionale
                con i propri clienti.
              </p>
            </div>
          </section>

          {/* 3 · COME FUNZIONA */}
          <section data-testid="coc-section-come">
            <h2 className="text-2xl font-bold text-[#0A0A0A] mb-6">Come funziona</h2>
            <ol className="space-y-6 list-none pl-0">
              {STEPS.map((s, i) => (
                <li key={i} className="flex gap-4" data-testid={`coc-come-step-${i + 1}`}>
                  <div className="flex-shrink-0 w-9 h-9 rounded-full bg-[#B40101] text-white text-sm font-bold flex items-center justify-center">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="flex-1 pt-1">
                    <p className="font-semibold text-[#0A0A0A] mb-1">{s.title}</p>
                    <div className="text-[15px] leading-relaxed text-[#0A0A0A]">{s.body}</div>
                  </div>
                </li>
              ))}
            </ol>
          </section>

          {/* 4 · CODICE DI CONDOTTA */}
          <section data-testid="coc-section-regole">
            <h2 className="text-2xl font-bold text-[#0A0A0A] mb-3">
              Il Codice di Condotta
            </h2>
            <p className="text-[15px] leading-relaxed text-[#0A0A0A] mb-6">
              L'adesione al programma Property Advisor comporta l'impegno a
              rispettare i principi professionali di ValutaGenio.
            </p>
            <ul className="space-y-5 list-none pl-0">
              {RULES.map((r, i) => (
                <li key={i} className="border-l-2 border-[#B40101] pl-4" data-testid={`coc-regola-${i + 1}`}>
                  <p className="font-semibold text-[#0A0A0A] mb-1">{i + 1}. {r.title}</p>
                  <p className="text-[15px] leading-relaxed text-[#0A0A0A]">{r.body}</p>
                </li>
              ))}
            </ul>
            <h3 className="text-base font-semibold text-[#0A0A0A] mt-8 mb-2">
              Rispetto delle regole
            </h3>
            <p className="text-sm text-[#B40101] font-medium bg-[#B40101]/5 border border-[#B40101]/20 rounded-lg p-4"
               data-testid="coc-conseguenze">
              Il mancato rispetto del Codice di Condotta può comportare
              provvedimenti sull'account, fino alla sospensione o all'esclusione
              dal programma Property Advisor, secondo le condizioni contrattuali
              applicabili.
            </p>
          </section>

          {/* 5 · CHIUSURA */}
          <section data-testid="coc-section-chiusura">
            <h2 className="text-2xl font-bold text-[#0A0A0A] mb-4">
              ValutaGenio: tecnologia, competenza e nuove opportunità.
            </h2>
            <div className="space-y-4 text-[15px] leading-relaxed text-[#0A0A0A]">
              <p>
                ValutaGenio mette a disposizione strumenti per esplorare il
                potenziale immobiliare, sviluppare contatti e costruire relazioni
                professionali fondate sulla fiducia.
              </p>
              <p>
                Il Property Advisor trasforma queste opportunità in orientamento,
                consulenza e progetti concreti.
              </p>
            </div>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-200 text-center">
          <Link to="/signup"
                className="vg-btn-primary inline-flex items-center gap-2"
                data-testid="coc-cta-signup">
            Torna alla registrazione →
          </Link>
        </div>
      </main>
    </div>
  );
}
